const IMAGE_BASE_PATH = '/images/products/';

const human_products = [
  {
    id: 'Or7rBW',
    name: '뉴질랜드 라이프스팬 울트라 플렉스 25000 + Vitamin D',
    amount: '90캡슐',
    price: '₩208,000',
    categories: [1],
    highlight: `1일 1회 섭취하는 GlycOmega-Oil™
    하루 한 개로 충분한 소프트 젤 캡슐은 뉴질랜드 말보로사운드의 청정해역에서 자란 초록입홍합으로부터 추출한 프리미엄급 GlycOmega-Oil™을 함유하고 있습니다. 이 오메가3의 천연 공급원은 관절 건강을 지켜주는 주요 영양소들을 담고 있습니다.`,
    description: `라이프스팬 뉴질랜드 초록입홍합 오일 25000은 프리미엄 저온 초임계 추출 방식을 통해 추출된 오일로 관절의 신축성을 향상시키고 편안함을 제공합니다. 초록입홍합으로부터 추출한 특허 추출물 GlycOmega-OIL이 함유되어 있습니다.
    오메가-3 지방산, 글루코사민, 글리코사미노글리칸 등의 주요 영양소를 보존하기 위해 홍합을 동결 건조하는 방식을 사용합니다.
    - 염증 및 통증 감소 
    - 흡수율을 최대 6배 높인 아쿠아셀 공법 적용
    - 복용하기 쉬운 젤 캡슐 형태
    - 영양 손실을 최소화한 초임계 추출
    전 세계의 수많은 사람들이 초록입홍합이 주는 혜택을 누리고 있습니다. 유연성을 향상시키고 관절염 증상을 완화시키는 것 등이 그 예입니다. 초록입홍합에 대한 과학적 기초 연구는 여전히 계속 진행 중이나, 수많은 연구들이 긍정적인 결과를 보여주었습니다.
    *GlycOmega-OIL은 AromaNZ의 등록 상표입니다.`,
    ingredient: `캡슐 당 성분 함량:
    - Dried Green-lipped mussel (GlycOmega-Oil™) / 200mg;  (Perna canaliculus) 
    – equiv. to fresh mussel / 25,000mg
    - New Zealand natural olive oil / 250mg
    - D-alpha tocopherol 1300I.U/g / 0.250mg
    - Encapsulating aid

    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.
    `,
    dosage: `성인 기준 1일 1캡슐을 음식과 함께 복용하시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류 및 갑각류에 알레르기가 있을 경우 섭취하지 마십시오.`,
    image: 'vitDplus6.jpg',
    link: null,
  },
  {
    id: 'uTkdsQ',
    name: '프리미엄 초록입홍합 오일 10000mg',
    amount: '200캡슐',
    price: '₩162,000',
    categories: [1],
    highlight: `초록입홍합10000 에는 뉴질랜드 말보로사운드의 청정해역에서 자란 초록입홍 에서 추출한 초록입홍합 오일(GlycOomega-OIL™)이 함유되어 있습니다. 이 풍부한 오메가-3 공급원은 100% 천연이며 최적의 관절 건강을 유지하는 데 도움을 줄 수 있는 영양소를 함유하고 있습니다.`,
    description: `프리미엄 초록입홍합 오일10000은 뉴질랜드에서 생산된 선별된 제품으로 GlycOmega-오일™을 함유하고 있으며, 글리코사미노글리칸스(GAGs)의 모든 주요 종류의 풍부한 성분을 제공합니다. 명확히 하자면, GAGs는 연골과 관절에서 발견되는 시신액의 주요 성분이다. (GAGs는 연골과 관절에서 발견되는 관절 낭액의 주요 성분입니다.)</p> <p class="sentence">퀸즐랜드 대학 실험의 연구원들은 보고에 따르면, 최근 실험에서 참가자에게서 관절통증의 59%가 감소하는 놀라운 효과를 보였다고 합니다. 궁극적으로 초록립홍합 오일은 관절통증과 염증의 제어 효과를 통해 이전에 누렸던 건강한 생활습관으로 돌아갈 수 있도록 도와줍니다.

    프리미엄 초록입홍합 오일 10000의 핵심 효과:
    - 100% 자연산 
    - 골관절염과 관련된 관절 염증을 감소시킬 수 있음
    - 풍부한 오메가3
    - 먹기 쉬운 형태`,
    ingredient: `각 캡슐 당 성분 함량:
    - Green-lipped mussel oil (GlycOmega-Oil™) (Perna canaliculus) 
    – equiv. to fresh mussel / 10000mg. 
    - New Zealand Natural Olive Oil, d-alpha tocopherol 1300I.U/g, 
    - encapsulation aids. 
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 1~3 캡슐을 충분한 물과 함께 섭취하거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류 및 갑각류에 알레르기가 있을 경우 복용하지 마십시오.`,
    image: 'GLM10000-FRONT.jpg',
    link: null,
  },
  {
    id: 'od35cy',
    name: '뉴질랜드 100% 콜로스트럼',
    amount: '60캡슐',
    price: '₩63,000',
    categories: [2, 3],
    highlight: `365일 자연방목한 건강한 뉴질랜드 소의 초유만을 담았습니다.
    `,
    description: `라이프스팬 초유만의 특징:
    - 면역 글로불린 lgG20-25% 함유
    - 분만 후 48시간 내 착유한 초유
    - 150년 전통 '웨스트랜드'사의 원료 사용, 
    - 하루 2정으로 1200mg 간편하게 섭취
    
    순수한 단백질 보충, 100% 초유만 포함된 제품, 면역인자 lgG함유 제품, 성장인자 IGF-1함유 제품을 찾으시는 분께 적합합니다.`,
    ingredient: `캡슐 당 성분: - 100% 소 초유 파우더(Bovine Colostrum Powder) / 600mg
    * 본 제품에는 밀, 글루텐, 이스트, 유제품, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    dosage: `12세 이하 어린이는 하루 1캡슐, 성인은 하루 2 캡슐을 식전에 물과 함께 드시거나 전문가와 상의하신 후에 드십시오. `,
    warnings: `어린이의 손에 닿지 않게 주의하십시오.
    순수 초유로 만들어진 제품이므로 유당불내증이 있는 분들은 섭취를 삼가시기 바랍니다.
    상단에 씰이 망가져있거나 없을경우 드시지 마세요.
    30도 이하의 건조한 곳에 보관하시고 직사광선을 피하세요.`,
    image: 'Colostrum_Front.png',
    link: null,
  },
  {
    id: 'vw527f',
    name: '달리아 4 Blood Sugar Support',
    amount: '60캡슐',
    price: '₩135,000',
    categories: [2, 6],
    highlight: `달리아 꽃에서 추출한 천연성분으로 혈당 조절에 도움을 받을 수 있습니다. `,
    description: `달리아 4가 주는 이점
    100% 천연 혈당유지 보조제, 
    간편하게 하루 두번 식전 한 캡슐 섭취하는 것만으로도 혈당 조절에 도움, 
    3 종류의 상호 의존적 화합물로 구성된 혈당수치 조절 보조제
    혈당 조절은 건강한 식단, 충분한 수면, 규칙적인 운동과 병행되었을 때 가장 좋은 효과를 보입니다.`,
    ingredient: `캡슐 당 성분:- Dahlia flower extract(Dahlia4) / 200mg
    * 본 제품에는 밀, 글루텐, 이스트, 유제품, 인공색소, 감미료, 방부제가 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 2번 1캡슐씩 식전에 드시거나, 전문가와 상의하신 후에 드십시오. `,
    warnings: `어린이의 손에 닿지 않게 주의하십시오.
    임산부의 경우 드시기 전에 반드시 전문가와 먼저 상의하십시오.
    상단에 씰이 망가져있거나 없을경우 드시지 마세요.
    30도 이하의 건조한 곳에 보관하시고 직사광선을 피하세요.`,
    image: 'Dahlia4-Boood_Sugar_Support.jpg',
    link: null,
  },
  {
    id: 'epb6R2',
    name: '빌베리+루테인 50000',
    amount: '60캡슐',
    price: '₩76,000',
    categories: [2, 4],
    highlight: `빌베리 + 루테인 50000는 눈 건강과 면역체계를 강화 시켜주는 좋은 방법입니다. 빌베리는 항산화 물질인 안토시아닌을 다량 함유하고 있습니다. 또한 마리골드 꽃 추출물을 함유, 루테인과 지아잔틴을 풍부하게 가지고 있습니다.`,
    description: `100% 천연 동결건조 파우더 함유.
    면역과 눈 건강을 지켜줍니다.
    인공적인 색소나 성분을 첨가하지 않았습니다. 
    하루 한 알로 손쉽게 눈 건강 관리.`,
    ingredient: `캡슐 당 성분:
    - Bilberry extract 100:1 (equiv. fresh 50000mg) / 500mg 
    - Lutein 80% (marigold flower extract) / 10mg 
    - Zeaxanthin 10% (marigold flower extract) / 2mg 
    - Zinc / 15mg
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다. 캡슐화를 위한 피막형성 보조제가 들어갔습니다.`,
    dosage: `하루 1캡슐식 섭취하세요, 혹은 의료 전문가와 상의하세요.`,
    warnings: `아연의 과섭취를 방지하기 위해 하루 1캡슐을 초과하여 드시지 마십시오.
    상단에 씰이 망가져있거나 없을경우 드시지 마세요.
    어린이의 손이 닿지 않는 곳에 보관하십시오.
    30도 이하의 건조한 곳에 보관하시고 직사광선을 피하세요.`,
    image: 'bilberry50000.jpg',
    link: null,
  },
  {
    id: 'pqT15a',
    name: '빌베리+루테인 츄 for Kids',
    amount: '200츄',
    price: '₩76,000',
    categories: [2, 4],
    highlight: `Wise Owl 빌베리 + 루테인 츄는 어린이들의 눈 건강과 면역체계를 도와주는 좋은 방법입니다. 베리류는 비타민과 미소 영양소들의 훌륭한 조합을 가지고 있습니다. 빌베리는 항 산화 물질인 '안토시아닌'을 풍부하게 함유하고 있습니다.`,
    description: `시력과 면역을 향상시켜주는 맛있는 츄: 
    어린이들이 먹기 좋은 츄 형태
    면역과 눈 건강을 지켜줍니다.
    인공적인 색소나 성분을 첨가하지 않았습니다.
    아이들이 아침이나 점심을 먹은 뒤에 손쉽게 섭취할 수 있습니다.`,
    ingredient: `캡슐 당 성분:
    - Bilberry extract 100:1 (equiv. fresh 5000mg) / 50mg 
    - Lutein 80% (marigold flower extract) / 5mg
    - Zeaxanthin 10% (marigold flower extract) / 1mg
    - Forest fruit/wildberry / 12.87mg
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다. 정제보조제, 소르비톨(대체당의 일종) 그리고 향미료가 들어갔습니다.`,
    dosage: `2세 이상의 어린이에게 하루 1~2개의 츄를 주세요, 혹은 의료 전문가와 상의하세요.`,
    warnings: `어린이가 섭취할 때 잘 먹는지 지켜보세요. 
    상단에 씰이 망가져있거나 없을경우 드시지 마세요.
    비타민은 음식으로 섭취하는 것이 부족할 때만 효과가 있습니다.
    25도 이하의 건조한 곳에 보관하시고 직사광선을 피하세요.`,
    image: 'bilberry_kids.jpg',
    link: null,
  },
  {
    id: '4KgGIS',
    name: '뉴질랜드 마린 콘드로이친 영양제',
    amount: '300캡슐',
    price: '₩156,000',
    categories: [1],
    highlight: `자연스러운 관절과 연골을 위한 공식
    라이프스팬 뉴질랜드 마린 콘드로이친 캡슐은 100% 천연 생선 연골 추출물로 만들어졌으며, 초록입홍합 파우더까지 더해져 관절염을 비롯한 연골 질환의 관리, 관절의 유연성, 이동성 등에 도움을 줍니다.`,
    description: `뉴질랜드 마린 콘드로이친의 핵심 효과:
    이동성 개선 도움
    관절의 불편함 감소에 도움
    관절 건강 및 연골 재생 지원`,
    ingredient: `각 캡슐당 성분:
    - New Zealand marine chondroitin powder / 637.5mg
    - New Zealand marine green-lipped mussel powder [GlycOmega-Plus] / 112.5mg
    *캡슐화 보조제가 들어있습니다. 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 1~2캡슐을 식사 전후로 드시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `* 어패류 및 갑각류에 알레르기가 있을 경우 복용하지 마십시오. 어린이의 손에 닿지 않는 곳에 두시고 30도 이하의 서늘한 곳에 보관하시기 바랍니다.`,
    image: 'chondroitin_front.jpg',
    link: null,
  },
  {
    id: 'N08Crj',
    name: '초록입홍합 오일 37000 120캡슐',
    amount: '120캡슐',
    price: '₩315,000',
    categories: [1, 2],
    highlight: `주요 효능:
    고성능 제조법을 통한 빠른 효과
    염증 및 통증 감소
    풍부한 오메가3
    다양한 필수 지방산
    섭취하기 쉬운 형태임상 연구 시행`,
    description: `1일 1회, GlycOmega-Oil™
    * 섭취를 통한 관절 및 기동성 향상
    본 제품은 부드러운 젤 캡슐로 1일 1회 섭취를 통해 관절의 편안함과 이동성을 돕습니다. 각 캡슐에는 오메가 3, 필수 지방산 등을 포함한 필수적인 영양소들이 함유되어 있다. 이것들은 관절의 통증과 부기를 줄이는데 도움을 줄 수 있습니다. 전 세계 수 많은 사람들이 골관절염으로 인해 고통을 겪고 있는 상황에서 우리는 이 효과적인 자연 보충제로 수월하게 그러한 문제를 겪는 사람들을 지원하는 것을 지향하고 있습니다.
    뉴질랜드의 아름다운 말보로사운드의 지속적인 농장에서 자라는 초록입홍합에서 추출된 프리미엄급의 초록입홍합 오일 GlycOmega-Oil™ 이 우리 제품의 주성분입니다. 이 순수한 천연 오일은 관절과 연골 건강을 보조하는데 인상적인 효능을 보여줍니다. 오메가 3 지방산은 건강에 있어 여러 가지 역할을 수행합니다. 관절들을 지탱할 뿐만 아니라, 그들은 또한 항염증 작용을 통해 뇌와 심장 기능에도 도움을 줄 수 있습니다. 우리는 다른 방법보다 프리미엄 GlycOmega-OIL™에 들어있는 미량 영양소를 더 많이 보존하기 위해 저온 초임계 추출법을 사용했습니다.`,
    ingredient: `캡슐 당 성분:
    - Green-lipped mussel oil (GlycOmega™-Oil) (Perna canaliculus): 296mg
    - Equiv. to fresh mussel: 37000mg
    - New Zealand olive oil: 200mg
    - d-alpha tocopherol: 4mg
    * 본 제품은 글루텐, 계란, 유제품, 인공색소, 감미료, 방부제 및 밀을 포함하지 않았습니다.`,
    dosage: `성인 기준 하루 1 캡슐을 섭취하시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `- 어패류 및 갑각류에 알레르기가 있다면 드시지 마십시오.
    - 30도 이하의 서늘하고 건조한 곳에 보관하십시오.
    - 어린아이의 손이 닿지 않는 곳에 두십시오.
    - 밀봉 포장지가 손상되어 있다면 드시지 마십시오.`,
    image: '37000_800x600px-Front.png',
    link: null,
  },
  {
    id: '9JzofX',
    name: '크릴 오일 750mg',
    amount: '60캡슐',
    price: '₩49,000',
    categories: [4],
    highlight: `오메가3 인지질과 강력한 항산화 아스타크산틴의 풍부한 공급원.`,
    description: `일상적인 뇌, 심장 그리고 간 건강 보조 
    라이프스팬 프리미엄 퓨어 크릴오일은 오메가-3와 항산화 성분이 풍부합니다. 이는 심장과 간의 건강을 보조하고 두뇌의 기능을 돕습니다. 항산화 아스타크산틴의 풍부한 공급원이기에 일반 생선 기름보다 오메가-3를 더 효과적으로 흡수하게 해줍니다. 
    과학적으로 보여주는 건강 효능:
    건강한 지방의 우수한 공급원
    염증 퇴치에 도움이 될 수 있음
    관절염 및 관절 통증 감소에 도움
    혈중 지질과 심장 건강 향상에 도움
    PMS(생리전증후군) 관리에 도움
    일반적 생선 기름보다 효과적인 Omega3 흡수 
    크릴오일에는 아스타크산틴이라는 분홍색-오렌지색소가 들어 있어 항염증 및 항산화 효과가 있습니다. 이것은 오메가 3의 체내 흡수를 향상시키고 효과를 강화시키는 것으로 여겨집니다. 몇몇 동물과 사람 대상의 연구를 통해 크릴 오일 보충제를 먹는 것이 관절 통증과 관절염 증상 개선에 도움이 된다는 것을 발견했습니다.
    본 제품은 100% 자연산이며 생태 친화적인 기술을 이용해 지속 가능하게 수확할 수 있도록 엄격하게 규제 되고 있습니다.`,
    ingredient: `-equiv. to Phospholipids / 300mg
    -equiv. to Marine Triglycerides (Omega 3) / 165mg 
    -equiv. to Eicosapentaenoic Acid (EPA) / 90mg 
    -equiv. to Docosahexaenoic Acid (DHA) / 49mg
    -equiv. to Astaxanthin (Free) / 150mcg
    * 본 제품은 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다`,
    dosage: `1일 1캡슐을 음식과 함께 혹은 공복에 섭취하시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `-임신 혹은 수유중엔 섭취하지 마십시오.
    - 해산물에 알레르기가 있을 시엔 복용을 피해 주십시오.
    - 수술이 있을 시 최소 2주 전엔 복용을 중단하십시오.
    - 항상 라벨을 읽고 복용법을 따라 주십시오.
    - 만일 혈액 희석제를 복용해야 한다면 그 전에 반드시 의사와 상의하십시오.
    - 만일 처방약을 복용중이거나 곧 복용할 가능성이 있을 경우, 전문가와 상의하십시오.`,
    image: 'Krilloil1.jpg',
    link: null,
  },
  {
    id: 'Q7xdLQ',
    name: '초록입홍합 20000mg',
    amount: '200캡슐',
    price: '₩198,000',
    categories: [1],
    highlight: `프리미엄 Stabilised 초록입홍합 20000에는 뉴질랜드 말보로사운드의 청정해역에서 수확한 초록입홍합에서 추출한 강력한 성분 GlycOmega-PLUS™가 함유되어 있습니다. 이 풍부한 천연 오메가3 공급원은 관절염으로 인한 염증을 줄이는데 도움이 되는 중요한 영양소들을 가지고 있습니다. 
    퀸즐랜드 대학의 최근 실험에서, 참가자들이 59%의 통증 감소 효과를 보았다고 보고되면서 그 비범한 효과가 인상을 준 바 있습니다.`,
    description: `초록입홍합 20000의  GlycOmega-PLUS™이 주는 효과를 누려보세요.
    초록입홍합 보조제를 꾸준히 복용하면 관절 이동성 향상에 도움이 됩니다. 이 제품의 주성분은 천연 오메가3와 필수 지방산이 풍부한 GlycOmega-PLUS입니다. 따라서, 관절 조직의 회복과 관절염의 증상을 줄이는 데 도움이 될 수 있습니다. 
    GlycOmega™-PLUS는 프리미엄급 초록입홍합 파우더 입니다. 뉴질랜드에서 수확된 본 제품은 모든 주요 종류의 글리코사미노글리칸스(GAGs)를 풍부하게 제공한다. (GAGs는 연골과 관절에서 발견되는 관절 낭액의 주요 성분입니다.)
    GAGs는 관절 연골에 유연성, 탄력성, 항장력을 제공합니다. 무엇보다 관절염의 중증도는 관절 및 주변 연골의 GAGS 소실과 직결됩니다.
    GAGs의 공급원으로서 GlycOmega ™는 콘드로이티테스에게 필수 지방산을 공급해 줍니다. 이것들은 관절염 진행을 되돌리는 데 매우 중요하며, 결합조직에 강한 항염증 작용을 할 수 있습니다.
    퀸즐랜드 대학 실험의 연구원들은 최근 실험에서 참가자들 사이에서 관절통증의 59%를 감소시켰다는 놀라운 결과를 보고했습니다.
    * GlycOmega-PLUS 는 AromaNZ의 등록 상표입니다.`,
    ingredient: `각 캡슐 당 성분:
    - Dried Green-lipped mussel (GlycOmega-PLUS™) / 800mg; (Perna canaliculus)
    – equiv. to fresh mussel / 20,000mg.
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 2~3캡슐을 식사와 함께 섭취하시거나 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류 및 갑각류에 알레르기가 있을 경우 섭취하지 마십시오.`,
    image: '20000_new_front.jpg',
    link: null,
  },

  {
    id: 'hhzpon',
    name: '뉴질랜드 마린 콜라겐 500mg',
    amount: '60캡슐',
    price: '₩32,500',
    categories: [5],
    highlight: `핵심 효능:
    피부톤 유지
    100% 자연산
    손발톱 강화
    모발 강화
    피부 재생 및 회복 지원`,
    description: `체내에서 가꾸는 미용 공식 – 내부 광채
    본 제품은 체내 미용을 위한 콜라겐 제품으로 피부, 머리카락, 손톱의 일상 건강에 활력을 불어넣습니다. 손상된 부분의 빠른 회복을 통해 눈에 띌 만한 효과를 경험하세요.
    본 제품에 사용되는 마린 콜라겐은 뉴질랜드의 청정해역에서 지속적으로 수확됩니다. 피부의 자연적인 보강과 재생 과정을 돕기 위한 필수 영양소를 공급합니다.
    또한 여기엔 다당류, 비타민, 필수 해양 미네랄도 함유되어 있습니다. 따라서 놀라운 보습과 피부미용 효과를 제공하며, 정맥에서 신체의 결합 조직이 치유되고 만들어 지는 것을 도와줍니다.
    콜라겐은 인대, 관절, 머리카락, 피부, 손톱을 구성하는 주요 천연 단백질이며, 또한 우리의 신체 여러 부분의 구성 성분이기도 합니다.`,
    ingredient: `각 캡슐 당 성분 함량:
    - New Zealand Lyophilised Marine Collagen / 500mg.
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공 색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준, 하루에 2 캡슐을 물과 함께 드시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류나 해조류에 알레르기가 있을 경우 섭취하지 마십시오.`,
    image: 'MarineCollagen.jpg',
    link: null,
  },
  {
    id: 'wXj9N_',
    name: '초록입홍합 12500mg',
    amount: '60캡슐',
    price: '₩32,500',
    categories: [1],
    highlight: `초록입홍합1250에는 뉴질랜드 말보로사운드의 청정 해역에서 자란 초록입홍합에서 추출한 강력한 복합성분인 GlycOmega-PLUS™가 함유되어 있습니다. 오메가3의 이 천연 공급원은 정상적인 관절 건강을 유지하는데 도움이 되는 귀중한 영양소를 담고 있습니다.`,
    description: `GlycOmega™ 는 프리미엄급 초록입홍합 파우더 입니다. 뉴질랜드에서 수확된 본 제품은 모든 주요 종류의 글리코사미노글리칸스(GAGs)를 풍부하게 제공한다. (GAGs는 연골과 관절에서 발견되는 관절 낭액의 주요 성분입니다.) 퀸즐랜드 대학 실험의 연구원들은 최근 실험에서 참가자들 사이에서 관절 통증의 59%를 감소 시켰다는 놀라운 결과를 보고했습니다.</p><p>GAGs는 관절 연골에 유연성, 탄력성, 항장력을 제공한다. 무엇보다 관절염의 중증도는 관절 및 주변 연골의 GAGs 소실과 직결됩니다.</p><p>&nbsp;</p><p class="sentence">GAGs의 공급으로서 GlycOmega ™는 콘드로이티테스에게 필수 지방산을 공급해 줍니다. 이것들은 관절염 진행을 되돌리는 데 매우 중요하며, 결합조직에 강한 항염증 작용을 할 수 있습니다.
    GlycOmega™에는 킬레이트 화합물의 미네랄, 아미노산, 필수 지방산이 함유되어 있습니다. 그래서 이것들은 연골 건강을 촉진시키고 충격 흡수성을 향상시키기 위해 함께 작용합니다. 또한 GlycOmega™가 아스피린과 같거나 그 이상의 항염증 활성작용을 하는 것으로 밝혀졌습니다.
    초록입홍합 12500의 핵심 효능:
    염증 및 통증 완화
    관절 이동성과 편안함 지원
    과학적 실험을 통한 입증
    피부 재생과 회복에 도움
    
    * GlycOmega는 Aroma NZ의 등록 상표입니다.`,
    ingredient: `각 캡슐당 성분 함량:
    - Dried Green-lipped mussel (GlycOmega-PLUS™) / 500mg; (Perna canaliculus)
    – equiv. to fresh mussel / 12500mg.
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 2~3캡슐을 식사와 함께 섭취하시거나 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `* 어패류 및 갑각류에 알레르기가 있을 경우 섭취하지 마십시오.`,
    image: 'WEB12500GLM500x900new.jpg',
    link: null,
  },
  {
    id: 'kn7s47',
    name: '초록입홍합 12500mg',
    amount: '300캡슐',
    price: '₩156,000',
    categories: [1],
    highlight: `초록입홍합1250에는 뉴질랜드 말보로사운드의 청정 해역에서 자란 초록입홍합에서 추출한 강력한 복합성분인 GlycOmega-PLUS™가 함유되어 있습니다. 오메가3의 이 천연 공급원은 정상적인 관절 건강을 유지하는데 도움이 되는 귀중한 영양소를 담고 있습니다.`,
    description: `GlycOmega™ 는 프리미엄급 초록입홍합 파우더 입니다. 뉴질랜드에서 수확된 본 제품은 모든 주요 종류의 글리코사미노글리칸스(GAGs)를 풍부하게 제공한다. (GAGs는 연골과 관절에서 발견되는 관절 낭액의 주요 성분입니다.) 퀸즐랜드 대학 실험의 연구원들은 최근 실험에서 참가자들 사이에서 관절 통증의 59%를 감소 시켰다는 놀라운 결과를 보고했습니다.</p><p>GAGs는 관절 연골에 유연성, 탄력성, 항장력을 제공한다. 무엇보다 관절염의 중증도는 관절 및 주변 연골의 GAGs 소실과 직결됩니다.</p><p>&nbsp;</p><p class="sentence">GAGs의 공급으로서 GlycOmega ™는 콘드로이티테스에게 필수 지방산을 공급해 줍니다. 이것들은 관절염 진행을 되돌리는 데 매우 중요하며, 결합조직에 강한 항염증 작용을 할 수 있습니다.
    GlycOmega™에는 킬레이트 화합물의 미네랄, 아미노산, 필수 지방산이 함유되어 있습니다. 그래서 이것들은 연골 건강을 촉진시키고 충격 흡수성을 향상시키기 위해 함께 작용합니다. 또한 GlycOmega™가 아스피린과 같거나 그 이상의 항염증 활성작용을 하는 것으로 밝혀졌습니다.
    초록입홍합 12500의 핵심 효능:
    염증 및 통증 완화
    관절 이동성과 편안함 지원
    과학적 실험을 통한 입증
    피부 재생과 회복에 도움
    
    * GlycOmega는 Aroma NZ의 등록 상표입니다.`,
    ingredient: `각 캡슐당 성분 함량:
    - Dried Green-lipped mussel (GlycOmega-PLUS™) / 500mg; (Perna canaliculus)
    – equiv. to fresh mussel / 12500mg.
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 2~3캡슐을 식사와 함께 섭취하시거나 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `* 어패류 및 갑각류에 알레르기가 있을 경우 섭취하지 마십시오.`,
    image: 'glm12500-300cap900x900.png',
    link: null,
  },
  {
    id: '9nZlt-',
    name: '조인트 & 머슬 서포트 초록입홍합 오일 크림',
    amount: '45g',
    price: '₩38,000',
    categories: [1],
    highlight: ``,
    description: `천연 원료로 제조된 연고. 다양한 고효능의 자연 원료들의 조합을 통해 신체의 자연 치유력을 높여줍니다.
    
    핵심 효능:
    직접적으로 뻣뻣한 관절과 근육 완화를 도움
    자연산 오일들의 독자적인 조합
    100% 천연
    파라벤, 색소, 인공첨가물 없음`,
    ingredient: `- Water, Almond oil, Grapeseed oil, Peppermint oil, Arnica oil, Black pepper oil, Manuka oil, Eucalyptus oil, Marjoram oil, Green-lipped Mussel oil, Bees wax, PEG 20 stearate, Stearic acid, Polysorbate, Cetearyl alcohol, Geogard 221, Sodium carbomer`,
    dosage: `바르시고자 하는 부위에 하루에 2~3회 고르게 펴 발라 주십시오. 외용으로만 사용해 주십시오.
    전문가와의 상담을 통해 조절할 수 있습니다.`,
    warnings: `어패류 및 갑각류에 알레르기가 있을 경우 사용하지 마십시오.
    눈에 닿지 않도록 주의하십시오. 
    상처가 있거나 감염의 우려가 있는 부분엔 사용하지 마십시오. 
    임신 중에는 사용하지 않기를 권합니다.
    어린이의 손에 닿지 않게 주의해주세요.
    통증이 오랫동안 지속될 경우, 전문가를 찾으십시오.`,
    image: '7789-Joint&Muscle-Support.jpg',
    link: null,
  },
  {
    id: 'OBhRb8',
    name: '사과식초 캡슐 750mg',
    amount: '60캡슐',
    price: '₩60,000',
    categories: [3, 5],
    highlight: `‘초산균’을 함유한 천연 해독법
    사과식초는 간, 신장, 결장의 해독을 돕고 혈압을 조절하며 콜레스테롤을 낮추는 등 여러 가지 건강상의 이점을 가지고 있는 것으로 밝혀졌습니다. 이 각각의 캡슐에는 아세트산과 비타민 B1, B2, B6, 비타민C와 필수 미량영양소가 함유되어 있습니다.`,
    description: `사과 식초의 특이한 맛 때문에 사람들은 이것을 섭취하는 것을 주저하곤 합니다. 더군다나 직접 마시는 것은 치아를 에나멜 침식의 위험에 빠뜨릴 수도 있습니다. 그렇기 때문에 라이프스팬 유기농 사과식초 캡슐을 섭취하면 그런 부담 없이 사과 식초의 이점을 누릴 수 있습니다.

    유기농 사과식초의 핵심 효능:
    - 장 건강의 유지 
    - 혈압과 콜레스테롤 수치 조절
    - 간과 신장 기능을 지원 
    - 체중관리와 식욕 조절
    
    이 캡슐 제조에 사용되는 과정은 "초산균"이라는 유익한 배양균이 추출물에 남아 있음을 보장합니다. 그러나, 일부 사과식초 제품은 깨끗한 식초를 얻기 위해 이 침전물을 제거하는 여과 과정을 사용하기도 합니다. 두 방식의 차이점은 "초산균"이 아세트산 박테리아가 발견되는 곳이라는 점 입니다. 이것들은 염증을 줄이고 혈압을 관리하는 데 도움을 주는 특성들입니다.`,
    ingredient: `캡슐 당 성분 함량:
    - Organic apple cider vinegar powder extract (750mg)
    - Maltodextrin
    - Vegetarian coating
    - Stearic acid (vegetable source) 
    - Silicon dioxide
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제, 이스트, 밀, 어패류, 견과류가 포함되지 않았습니다. 또한 이러한 알레르기 유발 항원을 처리하는 GMP(Good Manufacturing Practice)시설에서 생산되었습니다.`,
    dosage: `성인 기준 하루 1 캡슐을 식사와 함께 섭취하시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `- 30도 이하의 건조한 장소에서 보관하십시오.
    - 어린이의 손이 닿지 않는 곳에 두십시오.`,
    image: 'acv_60_front.png',
    link: null,
  },
  {
    id: 'gjiW4h',
    name: '양태반 캡슐 80000',
    amount: '120캡슐',
    price: '₩148,000',
    categories: [3],
    highlight: `양태반 캡슐 80000의 핵심 효능:
    - 풍부한 비타민과 영양소를 함유하여 신체의 노화 대비
    - 신체 에너지, 성기능, 그리고 면역체계 보조
    - 친환경 기술을 사용한 100% 자연산, 지속가능한 수확
    - 주근깨, 흑점, 색소 침착의 완화
    - 건강하고 고른 피부톤 유지
    - 피부 보습 강화, 주름 개선
    - 피부탄력의 개선 및 처짐 감소`,
    description: `오랫동안 양태반은 중국을 비롯해 동양에서 건강과 미용을 위한 약재로 사용되어 왔습니다. 단백질과 아미노산, 각종 성장 요소의 자연 공급원으로 신체 내부로부터 아름다움을 유지할 수 있도록 도와줍니다.

    양태반은 철분, 아연 그리고 비타민E를 풍부하게 함유하고 있습니다. 이 무기질 성분들은 피부톤을 살려주고, 에너지를 보충해주며, 면역체계를 건강하게 유지하는데 도움을 줍니다. 또한 콜레스테롤 수치를 낮춰주며, 상처 치유의 속도를 높여주고, 숙면을 도와주며, 피부질환으로부터의 회복을 도와줍니다.`,
    ingredient: `각 캡슐 당 성분 함량:
    - Sheep Placenta Extract
    – Equiv. to fresh sheep placenta / 80,000mg
    - encapsulation aids. 
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루에 1캡슐을 섭취하거나 전문가와 상의해서 조절하실 수 있습니다.`,
    warnings: `임신중이거나 수유 중일 경우 드시지 마십시오.
      복용법에 맞게 섭취하시고, 이상 증상이 나타날 경우 전문가의 상담을 받으십시오.
      30도 이하의 서늘하고 건조한 장소에 보관하시고
      어린이나 반려동물이 닿을 수 없는 곳에 두십시오.
      만일 블리스터 패키지가 손상되었을 경우엔 드시지 마십시오.`,
    image: 'Sheep Placenta 80000_front on.png',
    link: null,
  },
  {
    id: 'pb23qD',
    name: '딥 오션 오메가-3',
    amount: '120캡슐',
    price: '₩42,000',
    categories: [2, 4],
    highlight: `고함량 피쉬 오일 (생선 기름)
      라이프스팬의 딥 오션 오메가3는 프리미엄급의 고강도 생선 기름입니다. 분자 증류와 수은 테스트를 통해 최고 수준의 순도와 품질을 보장하며, 무엇보다도 오메가 3와 지방산의 훌륭한 공급원입니다. 이 지방산들은 심장, 뇌, 눈, 그리고 관절을 비롯해 건강을 보조하는 중요한 성분들입니다.`,
    description: `딥 오션 오메가3는 건강을 여러 방면에서 보조하는 필수적인 영양소들을 함유하고 있습니다:
      심혈관 지원 – 생선기름은 오랜기간 심장병의 위험을 줄여주는 유명한 보충제로 알려져 있습니다. EPA와 DHA 오메가-3 지방산을 많이 함유하고 있어 염증을 감소시키고 중성지방의 수치를 낮춰 줍니다. 최근 미국에서 시행된 실험에서 환자들은 위약(속임약)을 받은 대조군 환자들에 비해 심장마비, 뇌졸중, 기타 심장질환의 위험이 상대적으로 25% 감소한 것으로 나타났습니다.
      관절 건강 – 매일 1~3g의 생선 기름을 섭취하면 관절의 불편함을 줄일 수 있는 것으로 알려져 있습니다. 예를 들어 아침에 느껴지는 뻣뻣함, 민감함, 붓기, 불편함 등이 있습니다. 또한 해당 분량의 오메가-3 지방산은 운동 시에 신체의 혈류를 증가시켜 관절의 통증이나 붓기를 줄일 수 있습니다.
      뇌 및 안구 기능 – 오메가3는 안구건조, 황반변성 등 특정 눈 질환의 위험을 줄여주는 것으로 나타났습니다.`,
    ingredient: `각 캡슐 당 성분 함량:
    - Natural fish oil (containing beneficial omega-3) / 1000mg;
    – Marine triglycerides, eicosapentaenoic acid (EPA) / 180mg;
    - Docosahexaenoic acid (DHA) / 120mg;
    - encapsulation aids. 
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 1~3캡슐 (어린이의 경우 1~2캡슐)을 음식과 함께 복용하시거나, 전문가와의 상담을 통해 결정하실 수 있습니다.`,
    warnings: `본 제품은 어류를 가공하여 생산되었습니다. 생선에 대한 알레르기가 있으실 경우 복용하지 마십시오. 어린이의 손이 닿지 않도록 주의해 주십시오.`,
    image: 'DeepOceanOmega500x900v2.jpg',
    link: null,
  },
  {
    id: 'bwf16Q',
    name: '액티 플렉스 90000 초록입 홍합환',
    amount: '30포',
    price: '₩115,000',
    categories: [1, 2],
    highlight: `이 제품은 뉴질랜드 말보로 사운드의 청정 해역에서 자란 초록입홍합으로부터 추출한 프리미엄 초록입홍합 파우더(GlycOmega-PLUS™)로 제조되었습니다. 이 천연 오메가3의 원천은 관절 건강을 유지하는데 도움을 주는 귀중한 영양소들을 함유하고 있습니다.`,
    description: `뉴질랜드 초록입홍합은 관절염으로 인한 통증과 염증을 줄이는데 도움을 주는 등의 효과가 입증되어, 천연 항염증 성분으로서 관절염 완화와 관절 연골 보호를 돕는다고 합니다.
      액티 플렉스 90000 초록입홍합환은 필수 미량요소들을 보존하도록 세심하게 추출된 프리미엄 초록입홍합 과립제(GlycOmega-PLUS™)만을 가지고 만들어졌습니다.
      각 포는 신선한 뉴질랜드 초록입 홍합 90,000mg에 해당하는 영양소를 가지고 있습니다.

      액티 플렉스 90000 초록입홍합환의 핵심효능:
        - 관절의 이동성과 편안함을 도움
        - 지속가능한 뉴질랜드의 수확방식
        - 무방부제
        - 풍부한 오메가3`,
    ingredient: `1포 당 함량 성분:
    - 초록입홍합 파우더 (GlycOmega-PLUS™) / 3.6mg
    - 홍합 90,000mg와 동일한 분량
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준: 하루에 1포를 섭취, 혹은 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류 및 갑각류에 알레르기가 있을 경우 복용하지 마십시오.`,
    image: 'GLM-photo-showing-3-sides-1-e1605565501564.png',
    link: null,
  },
  {
    id: 'den7b1',
    name: '활력 굴 추출 영양제 500mg',
    amount: '60캡슐',
    price: '₩28,000',
    categories: [2, 3],
    highlight: `천연의 활력 보조제 – 활력 굴 추출물은 뉴질랜드 청정 해역에서 자란 굴에서 추출되여 최적의 순도를 제공한다. 당신의 건강과 활력을 돕고, 신경 기능을 보조하며, 에너지 수준을 높이는 농축 천연 영양소를 담고 있습니다.`,
    description: `활력 굴 추출물은 태평양에서 서식하는 굴 종(Crassostrea gigas)이며 청정한 물에서 자라 최상의 순도를 자랑하며, 가장 농축된 형태일 때에 채취됩니다. 무엇보다 어떤 인공 첨가물도 들어가지 않습니다.
        본 제품은 아연, 타우린, 아미노산의 천연 공급원입니다. 따라서 꾸준히 복용하시면, 에너지와 면역력 향상에 도움을 줍니다.

        활력 굴 추출물의 핵심 효능:
          - 성기능 향상
          - 체력 증진
          - 에너지 부스터
          - 생식 및 면역 체계 지원`,
    ingredient: `캡슐 당 함량 성분:
    - Freeze-dried oyster extract / 500mg
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 2 캡슐을 섭취하시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류 및 갑각류에 알레르기가 있을 경우 복용하지 마십시오.`,
    image: 'WEBEnergizeOysterExtract500x900.jpg',
    link: null,
  },
  {
    id: 'pb1G1f',
    name: '켈프(해조류) 600mg',
    amount: '60캡슐',
    price: '₩29,000',
    categories: [2, 5],
    highlight: `뉴질랜드산 해초에는 갑상선의 기능을 돕는 농축된 천연 영양원으로 조직 회복, 피부 탄력, 면역력 증진에 도움이 될 수 있는 미네랄이 풍부하다. 이 해초는 뉴질랜드 남섬의 천연 그대로의 영양분이 풍부한 바닷물에 있는 농장에서 지속적으로 수확됩니다.`,
    description: `뉴질랜드 해초의 핵심 효능:

        - 조직 재생과 건강한 갑상선 기능 지원
        - 건강한 소화 및 면역 체계 지원
        - 피부, 머리카락, 손톱의 건강한 성장을 촉진
        - 체내의 면역력을 염두해야 하는 데는 여러가지 이유가 있습니다. 무엇보다, 여러분의 건강을 지켜줍니다.`,
    ingredient: `캡슐 당 함량 성분:
    - Dried pure New Zealand seaweed / 600mg.
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 매일 아침 2 캡슐을 음식과 드시는 것이 가장 좋으며, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `갑상선 질환이 있는 경우, 먼저 건강 전문가와 상의하여 요오드 섭취 한도를 확인하십시오.`,
    image: 'Seaweed60capbottle-1.jpg',
    link: null,
  },
  {
    id: 'vn72vH',
    name: '맥시 플렉스초록입홍합 오일 16000mg',
    amount: '120캡슐',
    price: '₩168,000',
    categories: [1, 2],
    highlight: `본 제품에는 뉴질랜드 말보로사운드의 청정해역에서 수확한 초록입홍합에서 추출한 프리미엄급 초록입홍합 오일(GlycOmega-Oil™)이 함유되어 있습니다. 천연 오메가 3는 정상적인 관절 건강을 유지하는데 도움을 줄 수 있는 귀중한 영양소를 함유하고 있습니다.`,
    description: `맥시-플렉스 16000 초록입홍합 오일은 프리미엄 관절 건강 보충제로서 오메가-3가 풍부합니다. DHA와 EPA 같이 중요한 요소들이 관절 이동성과 편안함을 지원하는 데 도움이 됩니다.

      맥시-플렉스 16000 초록입홍합 오일의 핵심 효능:

       - 관절 이동성과 편안함 지원
       - 뉴질랜드의100% 지속 가능한 수확
       - 무방부제
       - 풍부한 오메가3
       - 먹기 쉬운 형태`,
    ingredient: `캡슐 당 함량 성분:
      - Green-lipped mussel oil (GlycOmega-Oil™) (Perna canaliculus),
      - New Zealand Natural Olive Oil,
      - d-alpha tocopherol 1300I.U/g,
      - encapsulation aids.
    
    * 본 제품에는 글루텐, 계란, 유제품, 콩, 인공색소, 감미료, 방부제 및 밀이 포함되지 않았습니다.`,
    dosage: `성인 기준 하루 1~3 캡슐을 충분한 물과 복용하시거나, 전문가와의 상담을 통해 조절하실 수 있습니다.`,
    warnings: `어패류나 갑각류에 알레르기가 있으실 경우 복용하지 마십시오.`,
    image: 'greenlipped16000_120s_900.png',
    link: null,
  },
];

function generateSlug(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9가-힣]/g, '-') // 특수문자를 하이픈으로 변경
    .replace(/-+/g, '-') // 여러 하이픈을 하나로 합침
    .replace(/^-|-$/g, ''); // 앞뒤 하이픈 제거
}

// 기존 데이터에 슬러그 추가
const human_products_with_slug = human_products.map((product) => ({
  ...product,
  slug: product.slug || generateSlug(product.name),
}));

const categories = [
  { id: 1, path: 'joint', name: '관절 영양제', amount: 12 },
  { id: 2, path: 'immune', name: '면역력 강화', amount: 2 },
  { id: 3, path: 'energy', name: '에너지 증강', amount: 3 },
  { id: 4, path: 'brain-and-eyes', name: '두뇌와 눈 건강', amount: 3 },
  { id: 5, path: 'cosmetics', name: '미용 보조', amount: 3 },
  { id: 6, path: 'glucose', name: '혈당조절', amount: 1 },
];

function getProductImagePath(fileName) {
  return `${IMAGE_BASE_PATH}${fileName}`;
}

export {
  human_products_with_slug,
  categories,
  IMAGE_BASE_PATH,
  getProductImagePath,
};
